__turbopack_context__.v({
  "connector": "StatsStacked-module-scss-module__3G3MiW__connector",
  "connectorText": "StatsStacked-module-scss-module__3G3MiW__connectorText",
  "ctaText": "StatsStacked-module-scss-module__3G3MiW__ctaText",
  "description": "StatsStacked-module-scss-module__3G3MiW__description",
  "dividerLine": "StatsStacked-module-scss-module__3G3MiW__dividerLine",
  "firstStep": "StatsStacked-module-scss-module__3G3MiW__firstStep",
  "layer": "StatsStacked-module-scss-module__3G3MiW__layer",
  "stack-module-0": "StatsStacked-module-scss-module__3G3MiW__stack-module-0",
  "stack-module-1": "StatsStacked-module-scss-module__3G3MiW__stack-module-1",
  "stack-module-10": "StatsStacked-module-scss-module__3G3MiW__stack-module-10",
  "stack-module-11": "StatsStacked-module-scss-module__3G3MiW__stack-module-11",
  "stack-module-12": "StatsStacked-module-scss-module__3G3MiW__stack-module-12",
  "stack-module-13": "StatsStacked-module-scss-module__3G3MiW__stack-module-13",
  "stack-module-14": "StatsStacked-module-scss-module__3G3MiW__stack-module-14",
  "stack-module-15": "StatsStacked-module-scss-module__3G3MiW__stack-module-15",
  "stack-module-16": "StatsStacked-module-scss-module__3G3MiW__stack-module-16",
  "stack-module-17": "StatsStacked-module-scss-module__3G3MiW__stack-module-17",
  "stack-module-18": "StatsStacked-module-scss-module__3G3MiW__stack-module-18",
  "stack-module-19": "StatsStacked-module-scss-module__3G3MiW__stack-module-19",
  "stack-module-2": "StatsStacked-module-scss-module__3G3MiW__stack-module-2",
  "stack-module-20": "StatsStacked-module-scss-module__3G3MiW__stack-module-20",
  "stack-module-3": "StatsStacked-module-scss-module__3G3MiW__stack-module-3",
  "stack-module-4": "StatsStacked-module-scss-module__3G3MiW__stack-module-4",
  "stack-module-5": "StatsStacked-module-scss-module__3G3MiW__stack-module-5",
  "stack-module-6": "StatsStacked-module-scss-module__3G3MiW__stack-module-6",
  "stack-module-7": "StatsStacked-module-scss-module__3G3MiW__stack-module-7",
  "stack-module-8": "StatsStacked-module-scss-module__3G3MiW__stack-module-8",
  "stack-module-9": "StatsStacked-module-scss-module__3G3MiW__stack-module-9",
  "statValue": "StatsStacked-module-scss-module__3G3MiW__statValue",
  "statsStacked": "StatsStacked-module-scss-module__3G3MiW__statsStacked",
  "stickyContainer": "StatsStacked-module-scss-module__3G3MiW__stickyContainer",
  "z-base": "StatsStacked-module-scss-module__3G3MiW__z-base",
  "z-content": "StatsStacked-module-scss-module__3G3MiW__z-content",
  "z-footer": "StatsStacked-module-scss-module__3G3MiW__z-footer",
  "z-header": "StatsStacked-module-scss-module__3G3MiW__z-header",
  "z-hero": "StatsStacked-module-scss-module__3G3MiW__z-hero",
  "z-logo": "StatsStacked-module-scss-module__3G3MiW__z-logo",
  "z-logo-effect": "StatsStacked-module-scss-module__3G3MiW__z-logo-effect",
  "z-navigation": "StatsStacked-module-scss-module__3G3MiW__z-navigation",
  "z-sub": "StatsStacked-module-scss-module__3G3MiW__z-sub",
});
